import { Component, OnInit } from '@angular/core';
import { Invoice } from '../shared/models/invoice';
import { format} from 'date-fns';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { PpsUtilityService } from '../services/pps-utility.service';

@Component({
  selector: 'pps-project-invoice-form',
  templateUrl: './project-invoice-form.component.html',
  styleUrls: ['./project-invoice-form.component.css']
})
export class ProjectInvoiceFormComponent implements OnInit {
  invoice: Invoice = new Invoice();
  invoiceImage: File = null;
  fileToUpload: any = null;

  imageUrl: string = "";
  fileSize: string = "";

  constructor(
    private _dialogRef: DynamicDialogRef,
    private _util: PpsUtilityService
  ) { }

  ngOnInit(): void {
    this.init();
  }

  private init(){
    this.fileToUpload = {
      isImage: false,
      name: "",
      width: 0,
      height: 0,
      fileSize: "",
      previewSize: "100% 190px"
    };
  }

  save(form){
    if (form.invalid){
      return;
    }

    let formData = new FormData();
    if (this.invoiceImage){
      formData.append("ZoesenDocument", this.invoiceImage);
    }

    for(var name in this.invoice){
      if (this.invoice.hasOwnProperty(name)){
        var value = this.invoice[name];
        if (typeof value.getMonth === 'function'){ // Is of Date type
          value = format(value, "dd/MM/yyyy");
        }
        formData.append(name, value);
      }
    }

    this._dialogRef.close(formData);
  }

  cancel(){
    this._dialogRef.close();
  }
  
  clearAttachment(){
    this.init();
    this.invoiceImage = null;
    this.imageUrl = "";
  }

  onFileSelectionChange(event: any) {
    if (event.target.files && event.target.files[0]) {
      this.invoiceImage = event.target.files[0];
      this.fileToUpload = {
        isImage: false,
        name: this.invoiceImage.name,
        width: 0,
        height: 0,
        fileSize: this._util.formatBytes(this.invoiceImage.size)
      };

      this.imageUrl = "";
      
      if (this.invoiceImage.type.startsWith("image/")){
        this.fileToUpload.isImage = true;
        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.imageUrl = `url(${event.target.result})`;
          let img = new Image();
          img.src = event.target.result;
          img.onload = () => {
            this.fileToUpload.width = img.width;
            this.fileToUpload.height = img.height;

            let ratio = img.width / img.height;

            this.fileToUpload.previewSize = `${(190 * ratio).toFixed(0)}px 190px`;
          }
        }
        reader.readAsDataURL(this.invoiceImage);
      }
    }else{
      this.invoiceImage = null;
    }
  }
}
